import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import pastFinancialOutlookIcon from '../../../images/insight360/360-financial-past-icon.png';
import bigTicketItemIcon from '../../../images/insight360/360-big-ticket-item-icon.png';
import consumerConfidence from '../../../images/insight360/360-consumer-confidence-icon.png';
import financialOutlookIcon from '../../../images/insight360/360-financial-outlook-icon.png';
import mediumTicketItem from '../../../images/insight360/360-medium-ticket-item-icon.png';
import propensityToBuy from '../../../images/insight360/360-propensity-to-buy-icon.png';
import publicActivitiesIcon from '../../../images/insight360/360-public-activities-icon.png';
import futurEconomicOutlookIcon from '../../../images/insight360/360-future-economic-outlook-icon.png';
import pastEconomicOutlook from '../../../images/insight360/360-past-economic-outlook-icon.png';

const iconComponents = [
  { id: '360ConsumerConfidenceIcon', selectedIcon: consumerConfidence },
  { id: '360BigTicketItemIcon', selectedIcon: bigTicketItemIcon },
  { id: '360FinancialPastIcon', selectedIcon: pastFinancialOutlookIcon },
  { id: '360FinancialOutlookIcon', selectedIcon: financialOutlookIcon },
  { id: '360MediumTicketItemIcon', selectedIcon: mediumTicketItem },
  { id: '360PropensityToBuyIcon', selectedIcon: propensityToBuy },
  { id: '360PublicActivitiesIcon', selectedIcon: publicActivitiesIcon },
  { id: '360FutureEconomicOutlookIcon', selectedIcon: futurEconomicOutlookIcon },
  { id: '360PastEconomicOutlookIcon', selectedIcon: pastEconomicOutlook },
];

class ProfilesOutlookDetails extends Component {
  getImageIcon = imageKey => {
    const imageComponent = _.find(iconComponents, { id: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }

  render() {
    return (
      this.props.outlookDetail !== undefined && (
        <div className="row demographic-detail-columns fullwidth">
          <div className="row demographic-detail-columns fullwidth profile-first-row">
             <div className="columns large-3 small-3 medium-3">
              {(this.props.outlookDetail.value.icon === undefined ||
              this.props.outlookDetail.value.icon === 'none.png') && (
                <div className="imageblock" />
              )}
              {this.props.outlookDetail.value.icon !== undefined && (
                <img
                  src={
                this.getImageIcon(
                  _.camelCase(
                    this.props.outlookDetail.value.icon.replace(
                      '.png',
                      '',
                    ),
                  ),
                )
                    }
                  className="profile-outlook-img profile-image-margin"
                />
              )}
            </div>
            <div className="columns large-9 small-9 medium-9">
              <div className="div-overflow">
                <div className="attitude-triple-comparision-metrics profile-outlook-type">
                  { this.props.outlookHeading}
                </div>
              </div>
              <p
                className="profile-outlook-text attitude-comparision-data"
                title={
                 this.props.outlookDetail.label
                }
              >
               {this.props.outlookDetail.label}
              </p>
              <div className="div-overflow">
                <div className="attitude-triple-comparision-metrics profile-outlook-matrix">
                  INDEX:&nbsp;&nbsp;
                  {
                   this.props.outlookDetail.value
                      .index
                  }{' '}
                  | REACH:&nbsp;&nbsp;
                  {
                      this.props.outlookDetail.value
                      .pct
                  }{' '}
                </div>
              </div>
            </div>
          </div>

        </div>
      )
    );
  }
}

ProfilesOutlookDetails.propTypes = {
  outlook: PropTypes.shape({}),
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(ProfilesOutlookDetails);
